/**
 * Phase 6 · the deal screens' strings — the `plan` part: the record's *Terv* (`dealPlan.*`) and
 * *Erőforrás* (`dealResource.*`) tabs. Spread into `HU` and `EN` in `../catalogue.ts`; a key in one
 * and not the other is a type error there.
 */
export const HU = {
  /* ── Terv · the line items ── */
  'dealPlan.lines.title': 'Sortételek',
  'dealPlan.lines.label': 'A deal sortételei',
  'dealPlan.action.newLine': 'Új sortétel',
  'dealPlan.action.deleteLine': 'Sortétel törlése',
  'dealPlan.column.name': 'Sortétel',
  'dealPlan.column.type': 'Típus',
  'dealPlan.column.status': 'Státusz',
  'dealPlan.column.milestone': 'Mérföldkő',
  'dealPlan.column.estimate': 'Becslés',
  'dealPlan.column.allocated': 'Allokált',
  'dealPlan.column.rate': 'Díj / egységár',
  'dealPlan.column.costBudget': 'Költségkeret',
  'dealPlan.column.amount': 'Összeg',
  'dealPlan.column.currency': 'Pénznem',
  'dealPlan.column.start': 'Kezdés',
  'dealPlan.column.end': 'Vég',
  'dealPlan.option.badge': 'opció',
  'dealPlan.option.hint':
    'Opció: ajánlott, de még el nem fogadott tétel — nem számít bele a deal értékébe és a tervbe.',
  'dealPlan.overAllocated': 'Több óra van allokálva, mint a becslés.',
  'dealPlan.footer': '{count} sortétel · Σ becslés {hours} · Σ összeg {amount}',
  'dealPlan.footer.options': 'opciók: {amount}, az összegben nincs benne',
  'dealPlan.empty.title': 'Nincs sortétel',
  'dealPlan.empty.body':
    'A sortételek adják a deal árát és a tervezett órákat. Vegyél fel egyet — a mérföldkövek és a külső költségek ráérnek.',
  'dealPlan.revenueMode': 'Bevételi ütem',
  'dealPlan.revenueMode.hint':
    'Ebből számol a forecast, és ez lesz a deal-ből generált szerződés típusa.',

  /* ── Terv · the line item dialog (`15b`) ── */
  'dealPlan.dialog.new': 'Új sortétel',
  'dealPlan.dialog.edit': 'Sortétel szerkesztése',
  'dealPlan.dialog.hint':
    'A deal-sortétel a terv egy vállalási egysége — becsléssel, költségkerettel és árral.',
  'dealPlan.field.name': 'Megnevezés',
  'dealPlan.field.namePlaceholder': 'pl. Készletmodul backend',
  'dealPlan.field.milestone': 'Mérföldkő',
  'dealPlan.field.noMilestone': '— nincs mérföldkő',
  'dealPlan.field.estimate': 'Becslés (óra)',
  'dealPlan.field.costBudget': 'Költségkeret',
  'dealPlan.field.rate': 'Díj / egységár',
  'dealPlan.field.rateUnit': 'Egység',
  'dealPlan.field.quantity': 'Mennyiség',
  'dealPlan.field.amount': 'Összeg (bevétel)',
  'dealPlan.field.currency': 'Pénznem',
  'dealPlan.field.compute': 'Díj × mennyiség',
  'dealPlan.field.computeHint': 'Az összeg kitöltése a díj és a mennyiség szorzatával',
  'dealPlan.error.name': 'A sortétel neve kötelező.',
  'dealPlan.error.dates': 'A vég dátum nem lehet a kezdés előtt.',
  'dealPlan.error.hours': 'A becslést órában add meg: 8, 8h, 8:00 vagy 8,0.',
  'dealPlan.error.quantity': 'A mennyiség nem negatív szám legyen.',
  'dealPlan.confirm.lineTitle': 'Törlöd a sortételt?',
  'dealPlan.confirm.lineBody':
    'A(z) „{name}” sortétel és az Erőforrás fülön rá tervezett órák törlődnek.',

  /* ── Terv · milestones ── */
  'dealPlan.milestones.title': 'Mérföldkövek',
  'dealPlan.milestones.label': 'A deal mérföldkövei',
  'dealPlan.milestones.add': 'Új mérföldkő',
  'dealPlan.milestones.empty':
    'Még nincs mérföldkő. Egy mérföldkő dátumhoz köti a sortételeket, és a bevételi ütem is számolhat vele.',
  'dealPlan.milestones.column.name': 'Név',
  'dealPlan.milestones.column.due': 'Határidő',
  'dealPlan.milestones.column.lines': 'Sortétel',
  'dealPlan.milestones.noDue': 'nincs dátum',
  'dealPlan.milestones.new': 'Új mérföldkő',
  'dealPlan.milestones.edit': 'Mérföldkő szerkesztése',
  'dealPlan.milestones.namePlaceholder': 'pl. Pilot 3 áruházban',
  'dealPlan.milestones.delete': 'Mérföldkő törlése',
  'dealPlan.milestones.confirmTitle': 'Törlöd a mérföldkövet?',
  'dealPlan.milestones.confirmBody':
    'A(z) „{name}” mérföldkő törlődik; a hozzá kötött sortételek megmaradnak, mérföldkő nélkül.',
  'dealPlan.milestones.errorName': 'A mérföldkő neve kötelező.',

  /* ── Terv · external costs ── */
  'dealPlan.costs.title': 'Külső költségek',
  'dealPlan.costs.label': 'A deal külső költségei',
  'dealPlan.costs.hint':
    'Alvállalkozó, licencbeszerzés, utazás — ami nem munkaóra, de a terv margóját csökkenti.',
  'dealPlan.costs.add': 'Külső költség',
  'dealPlan.costs.empty': 'Nincs külső költség a tervben.',
  'dealPlan.costs.column.name': 'Megnevezés',
  'dealPlan.costs.column.amount': 'Összeg',
  'dealPlan.costs.column.date': 'Dátum',
  'dealPlan.costs.new': 'Külső költség a tervbe',
  'dealPlan.costs.edit': 'Külső költség szerkesztése',
  'dealPlan.costs.namePlaceholder': 'pl. SAP-tanácsadó, 3 nap',
  'dealPlan.costs.delete': 'Külső költség törlése',
  'dealPlan.costs.confirmTitle': 'Törlöd a költséget?',
  'dealPlan.costs.confirmBody': 'A(z) „{name}” költség kikerül a tervből.',
  'dealPlan.costs.errorName': 'A költség megnevezése kötelező.',
  'dealPlan.costs.total': 'Σ {amount}',

  /* ── Erőforrás · the figures ── */
  'dealResource.tile.allocated': 'Σ allokált óra',
  'dealResource.tile.estimate': 'Σ becslés {hours}',
  'dealResource.tile.cost': 'Terv költség',
  'dealResource.tile.costSplit': 'munkaerő {labor} · külső {external}',
  'dealResource.tile.revenue': 'Bevétel',
  'dealResource.tile.revenueSub': 'a deal értéke',
  'dealResource.tile.margin': 'Terv margó',

  /* ── Erőforrás · the weekly grid ── */
  'dealResource.grid.label': 'Heti órák sortételenként és placeholderenként',
  'dealResource.column.item': 'Sortétel',
  'dealResource.column.total': 'Σ',
  'dealResource.week': '{week}. hét',
  'dealResource.weekOf': '{date} hete',
  'dealResource.weeks.earlier': 'Négy héttel korábbról',
  'dealResource.weeks.later': 'Négy héttel tovább',
  'dealResource.weeks.range': 'Megjelenített hetek',
  'dealResource.total': 'Összesen',
  'dealResource.rate': '{rate} / óra',
  'dealResource.headcount': '{count} fő',
  'dealResource.cell': '{name}, {week}',
  'dealResource.noRows': 'Ezen a sortételen még senkinek nincs órája.',
  'dealResource.addAllocation': 'Allokáció',
  'dealResource.addAllocationTo': 'Allokáció hozzáadása: {name}',
  'dealResource.menu.search': 'Szerepkör vagy dolgozó…',
  'dealResource.menu.empty': 'Nincs találat',
  'dealResource.menu.existing': 'A deal placeholderei',
  'dealResource.menu.profiles': 'Placeholder szerepkör',
  'dealResource.menu.people': 'Dolgozó — tentatív foglalás',
  'dealResource.menu.noProfiles':
    'Még nincs placeholder profil — a Deal menedzsment beállításaiban veheted fel.',
  'dealResource.tentative': 'Tentatív',
  'dealResource.tentative.hint':
    'Tentatív foglalás: valódi ember a terven. Az erőforrás-tervezőben csak a kapcsolójával látszik, és a kihasználtságba nem számít bele.',
  'dealResource.unattached': 'Órák nélküli placeholderek',
  'dealResource.unattached.hint':
    'Egy sortétel Allokáció menüjéből rendelheted őket a sortételhez.',
  'dealResource.drafts': 'Módosított cellák: {count}',
  'dealResource.discard': 'Elvetés',
  'dealResource.error.hours': 'Egy cella nem óra: írd 8, 8h, 8:00 vagy 8,0 alakban.',
  'dealResource.error.max': 'Egy cellában egy hétre legfeljebb 400 óra lehet.',
  'dealResource.empty.title': 'Nincs mire órát tervezni',
  'dealResource.empty.body':
    'Az órák fix és idő és anyag típusú sortételekre kerülnek. Vegyél fel egyet a Terv fülön, és itt hetekre bonthatod.',
  'dealResource.empty.action': 'Ugrás a Tervre',

  /* ── Erőforrás · a placeholder row ── */
  'dealResource.row.menu': 'Placeholder műveletei',
  'dealResource.row.edit': 'Placeholder szerkesztése',
  'dealResource.row.detach': 'Levétel erről a sortételről',
  'dealResource.row.delete': 'Placeholder törlése',
  'dealResource.edit.hint':
    'A név és a létszám a tervben látszik. Egy valódi ember ráültetése tentatív foglalás.',
  'dealResource.edit.name': 'Név',
  'dealResource.edit.headcount': 'Létszám',
  'dealResource.edit.headcountHint': 'A heti órák a teljes létszámra vonatkoznak.',
  'dealResource.edit.fewer': 'Kevesebb',
  'dealResource.edit.more': 'Több',
  'dealResource.edit.person': 'Ember a placeholderen',
  'dealResource.edit.personNone': 'Senki — csak a szerepkör',
  'dealResource.edit.personOff':
    'A tentatív foglalás ki van kapcsolva a Deal menedzsment beállításaiban.',
  'dealResource.edit.personKeep':
    'Profil nélküli placeholderről az ember nem vehető le — töröld inkább a placeholdert.',
  'dealResource.edit.errorName': 'A placeholder neve kötelező.',
  'dealResource.confirm.deleteTitle': 'Törlöd a placeholdert?',
  'dealResource.confirm.deleteBody':
    'A(z) „{name}” placeholder és minden heti órája törlődik a dealről, minden sortételről.',
  'dealResource.confirm.detachTitle': 'Leveszed a sortételről?',
  'dealResource.confirm.detachBody':
    'A(z) „{name}” placeholder órái erről a sortételről törlődnek: {hours}. A placeholder a dealen marad.',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'dealPlan.lines.title': 'Line items',
  'dealPlan.lines.label': "The deal's line items",
  'dealPlan.action.newLine': 'New line item',
  'dealPlan.action.deleteLine': 'Delete line item',
  'dealPlan.column.name': 'Line item',
  'dealPlan.column.type': 'Type',
  'dealPlan.column.status': 'Status',
  'dealPlan.column.milestone': 'Milestone',
  'dealPlan.column.estimate': 'Estimate',
  'dealPlan.column.allocated': 'Allocated',
  'dealPlan.column.rate': 'Rate / unit price',
  'dealPlan.column.costBudget': 'Cost budget',
  'dealPlan.column.amount': 'Amount',
  'dealPlan.column.currency': 'Currency',
  'dealPlan.column.start': 'Start',
  'dealPlan.column.end': 'End',
  'dealPlan.option.badge': 'option',
  'dealPlan.option.hint':
    "Option: offered but not yet accepted — it does not count toward the deal's value or the plan.",
  'dealPlan.overAllocated': 'More hours are allocated than estimated.',
  'dealPlan.footer': '{count} line items · Σ estimate {hours} · Σ amount {amount}',
  'dealPlan.footer.options': 'options: {amount}, not included in the amount',
  'dealPlan.empty.title': 'No line items',
  'dealPlan.empty.body':
    "Line items make up the deal's price and its planned hours. Add one — milestones and external costs can wait.",
  'dealPlan.revenueMode': 'Revenue schedule',
  'dealPlan.revenueMode.hint':
    'The forecast is computed from it, and it becomes the type of the contract generated from the deal.',

  'dealPlan.dialog.new': 'New line item',
  'dealPlan.dialog.edit': 'Edit line item',
  'dealPlan.dialog.hint':
    'A deal line item is one unit of what the plan commits to — with an estimate, a cost budget and a price.',
  'dealPlan.field.name': 'Name',
  'dealPlan.field.namePlaceholder': 'E.g. Inventory module backend',
  'dealPlan.field.milestone': 'Milestone',
  'dealPlan.field.noMilestone': '— no milestone',
  'dealPlan.field.estimate': 'Estimate (hours)',
  'dealPlan.field.costBudget': 'Cost budget',
  'dealPlan.field.rate': 'Rate / unit price',
  'dealPlan.field.rateUnit': 'Unit',
  'dealPlan.field.quantity': 'Quantity',
  'dealPlan.field.amount': 'Amount (revenue)',
  'dealPlan.field.currency': 'Currency',
  'dealPlan.field.compute': 'Rate × quantity',
  'dealPlan.field.computeHint': 'Fill in the amount as the rate times the quantity',
  'dealPlan.error.name': 'The line item needs a name.',
  'dealPlan.error.dates': 'The end date cannot be before the start.',
  'dealPlan.error.hours': 'Enter the estimate in hours: 8, 8h, 8:00 or 8,0.',
  'dealPlan.error.quantity': 'The quantity must be a number that is not negative.',
  'dealPlan.confirm.lineTitle': 'Delete the line item?',
  'dealPlan.confirm.lineBody':
    'The line item “{name}” and the hours planned on it in the Resources tab are deleted.',

  'dealPlan.milestones.title': 'Milestones',
  'dealPlan.milestones.label': "The deal's milestones",
  'dealPlan.milestones.add': 'New milestone',
  'dealPlan.milestones.empty':
    'No milestones yet. A milestone ties line items to a date, and the revenue schedule can follow it.',
  'dealPlan.milestones.column.name': 'Name',
  'dealPlan.milestones.column.due': 'Due',
  'dealPlan.milestones.column.lines': 'Line items',
  'dealPlan.milestones.noDue': 'no date',
  'dealPlan.milestones.new': 'New milestone',
  'dealPlan.milestones.edit': 'Edit milestone',
  'dealPlan.milestones.namePlaceholder': 'E.g. Pilot in 3 stores',
  'dealPlan.milestones.delete': 'Delete milestone',
  'dealPlan.milestones.confirmTitle': 'Delete the milestone?',
  'dealPlan.milestones.confirmBody':
    'The milestone “{name}” is deleted; its line items stay, without a milestone.',
  'dealPlan.milestones.errorName': 'The milestone needs a name.',

  'dealPlan.costs.title': 'External costs',
  'dealPlan.costs.label': "The deal's external costs",
  'dealPlan.costs.hint':
    "Subcontractors, licences bought in, travel — what is not working hours but still reduces the plan's margin.",
  'dealPlan.costs.add': 'External cost',
  'dealPlan.costs.empty': 'No external costs in the plan.',
  'dealPlan.costs.column.name': 'Name',
  'dealPlan.costs.column.amount': 'Amount',
  'dealPlan.costs.column.date': 'Date',
  'dealPlan.costs.new': 'External cost in the plan',
  'dealPlan.costs.edit': 'Edit external cost',
  'dealPlan.costs.namePlaceholder': 'E.g. SAP consultant, 3 days',
  'dealPlan.costs.delete': 'Delete external cost',
  'dealPlan.costs.confirmTitle': 'Delete the cost?',
  'dealPlan.costs.confirmBody': 'The cost “{name}” is removed from the plan.',
  'dealPlan.costs.errorName': 'The cost needs a name.',
  'dealPlan.costs.total': 'Σ {amount}',

  'dealResource.tile.allocated': 'Σ allocated hours',
  'dealResource.tile.estimate': 'Σ estimate {hours}',
  'dealResource.tile.cost': 'Plan cost',
  'dealResource.tile.costSplit': 'labour {labor} · external {external}',
  'dealResource.tile.revenue': 'Revenue',
  'dealResource.tile.revenueSub': "the deal's value",
  'dealResource.tile.margin': 'Plan margin',

  'dealResource.grid.label': 'Weekly hours by line item and placeholder',
  'dealResource.column.item': 'Line item',
  'dealResource.column.total': 'Σ',
  'dealResource.week': 'Week {week}',
  'dealResource.weekOf': 'week of {date}',
  'dealResource.weeks.earlier': 'Four weeks earlier',
  'dealResource.weeks.later': 'Four weeks further',
  'dealResource.weeks.range': 'Weeks shown',
  'dealResource.total': 'Total',
  'dealResource.rate': '{rate} / h',
  'dealResource.headcount': '{count} people',
  'dealResource.cell': '{name}, {week}',
  'dealResource.noRows': 'Nobody has hours on this line item yet.',
  'dealResource.addAllocation': 'Allocation',
  'dealResource.addAllocationTo': 'Add an allocation: {name}',
  'dealResource.menu.search': 'Role or person…',
  'dealResource.menu.empty': 'No matches',
  'dealResource.menu.existing': "The deal's placeholders",
  'dealResource.menu.profiles': 'Placeholder role',
  'dealResource.menu.people': 'Person — tentative booking',
  'dealResource.menu.noProfiles':
    'No placeholder profiles yet — add them in the Deal management settings.',
  'dealResource.tentative': 'Tentative',
  'dealResource.tentative.hint':
    'Tentative booking: a real person on the plan. The resource planner shows it only behind its toggle, and utilisation never counts it.',
  'dealResource.unattached': 'Placeholders without hours',
  'dealResource.unattached.hint': "Put them on a line item from that line item's Allocation menu.",
  'dealResource.drafts': 'Changed cells: {count}',
  'dealResource.discard': 'Discard',
  'dealResource.error.hours': 'A cell is not hours: write it as 8, 8h, 8:00 or 8,0.',
  'dealResource.error.max': 'A cell can hold at most 400 hours for a week.',
  'dealResource.empty.title': 'Nothing to plan hours on',
  'dealResource.empty.body':
    'Hours go on fixed and time-and-material line items. Add one in the Plan tab, then split it into weeks here.',
  'dealResource.empty.action': 'Go to the Plan',

  'dealResource.row.menu': 'Placeholder actions',
  'dealResource.row.edit': 'Edit placeholder',
  'dealResource.row.detach': 'Take off this line item',
  'dealResource.row.delete': 'Delete placeholder',
  'dealResource.edit.hint':
    'The name and the headcount show on the plan. Putting a real person on it is a tentative booking.',
  'dealResource.edit.name': 'Name',
  'dealResource.edit.headcount': 'Headcount',
  'dealResource.edit.headcountHint': 'The weekly hours are for the whole headcount.',
  'dealResource.edit.fewer': 'Fewer',
  'dealResource.edit.more': 'More',
  'dealResource.edit.person': 'Person on the placeholder',
  'dealResource.edit.personNone': 'Nobody — the role only',
  'dealResource.edit.personOff': 'Tentative booking is turned off in the Deal management settings.',
  'dealResource.edit.personKeep':
    'A placeholder with no profile cannot lose its person — delete the placeholder instead.',
  'dealResource.edit.errorName': 'The placeholder needs a name.',
  'dealResource.confirm.deleteTitle': 'Delete the placeholder?',
  'dealResource.confirm.deleteBody':
    'The placeholder “{name}” and every weekly hour of it are deleted from the deal, on every line item.',
  'dealResource.confirm.detachTitle': 'Take it off the line item?',
  'dealResource.confirm.detachBody':
    'The hours of “{name}” on this line item are cleared: {hours}. The placeholder stays on the deal.',
};
